import { ButtonGroup, Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { ArrowDropDown, Delete, Download } from "@mui/icons-material";
import { useCallback, useRef, useState } from "react";
import { useIntl } from "react-intl";
import "./index.css";
import { DocumentPreviewButton } from "../../../../../src/components/DocumentsTable/components/DocumentPreviewButton";
import Messages from "../../../../../src/localization/Messages";
import { IDocument } from "../../../../../src/models/document";

type DocumentMenuButtonGroupProps = {
    doc: IDocument;
    onDownload?: (document: IDocument) => void;
    onDelete?: (document: IDocument) => void;
};

function DocumentMenuButtonGroup({ doc, onDownload, onDelete }: DocumentMenuButtonGroupProps) {
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const menuButtonRef = useRef<HTMLButtonElement>(null);

    const handleToggle = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    const handleDownload = useCallback(() => {
        onDownload?.(doc);
        setOpen(false);
    }, [doc, onDownload]);

    const handleDelete = useCallback(() => {
        onDelete?.(doc);
        setOpen(false);
    }, [doc, onDelete]);

    return (
        <>
            <ButtonGroup variant="contained">
                <DocumentPreviewButton mimeType={doc.mimeType} name={doc.name} path={doc.path} />

                <Button size="small" ref={menuButtonRef} onClick={handleToggle}>
                    <ArrowDropDown />
                </Button>
            </ButtonGroup>

            <Menu anchorEl={menuButtonRef?.current} open={open} onClose={handleToggle}>
                {onDownload && (
                    <MenuItem onClick={handleDownload}>
                        <ListItemIcon>
                            <Download color="success" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{intl.formatMessage(Messages.download)}</ListItemText>
                    </MenuItem>
                )}
                {onDelete && (
                    <MenuItem onClick={handleDelete}>
                        <ListItemIcon>
                            <Delete color="error" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{intl.formatMessage(Messages.delete)}</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
}

export default DocumentMenuButtonGroup;
